
import { Modal, Table, Button } from 'antd';
import React from 'react';
import { fetchAccountingRecordFlowList } from '../../../services/accountingRecord';
import { findDict, formatTime } from '../../../utils';
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-21 14:36:54
 * @LastEditTime: 2021-12-22 11:53:26
 * @LastEditors: zhao - 🍉
 * @Description: 对账审批流程列表
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/components/FlowListModal.jsx
 */
class AccoungingRecordFlowListModal extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            loading: false,
            dataSource: []
        };
    }

    open = (id) => {
        this.setState({ visible: true });
        this.postFlowList(id)
    };

    close = () => {
        this.setState({ visible: false, dataSource: [] });
    };



    /** 
     * 商户对账审批流程列表
     */ 
    postFlowList(id) {
        const data = {accountingRecordLogId: id} 
        this.setState({ loading: true })
        fetchAccountingRecordFlowList(data).then((res) => {
            this.setState({ dataSource: res })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    renderFooter = () => {
        return <Button onClick={() => this.close()}>关闭</Button>
    }

    render() {
        const mapUserType = [
            { title: '平台人员', value: 1 },
            { title: '商户人员', value: 2 },
        ]
        const columns = [
            { title: '操作流程', dataIndex: 'operatingSteps' },
            { title: '用户类型', dataIndex: 'userType', render: (text) => {
                return findDict(mapUserType,text).title
            } },
            { title: '创建人', dataIndex: 'createByName' },
            { title: '创建时间', dataIndex: 'createTime', render: (text) => {
                return formatTime(text)
            } },
            { title: '备注信息', dataIndex: 'remarks' },
        ]
        return (
            <Modal title="对账审批流程列表" width={800} visible={this.state.visible} onCancel={this.close} footer={this.renderFooter()}>
                <Table 
                    loading={this.state.loading}
                    rowKey="id"
                    columns={columns}
                    dataSource={this.state.dataSource}
                    scroll={{x: 900}}
                />
            </Modal>
        );
    }
}

export default AccoungingRecordFlowListModal;




// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/FlowListModal.jsx